const isFormulaIdentifierCharacter = (char: string): boolean =>
    /^[A-Z0-9_]$/i.test(char)

const findFunctionOpeningParen = (
    formula: string,
    functionName: string
): number | null => {
    const upperFormula = formula.toUpperCase()
    const upperFunctionName = functionName.toUpperCase()
    const functionNames = [
        upperFunctionName,
        `_XLFN.${upperFunctionName}`,
        `_XLDUF.${upperFunctionName}`,
    ]
    let inQuotes = false

    for (let i = 0; i < formula.length; i++) {
        const char = formula[i]

        if (char === '"') {
            if (inQuotes && formula[i + 1] === '"') {
                i++
                continue
            }
            inQuotes = !inQuotes
            continue
        }

        if (inQuotes) {
            continue
        }

        for (const candidateName of functionNames) {
            if (!upperFormula.startsWith(candidateName, i)) {
                continue
            }

            const previousChar = i > 0 ? formula[i - 1] : ''
            if (previousChar && isFormulaIdentifierCharacter(previousChar)) {
                continue
            }

            let openingParenIndex = i + candidateName.length
            while (
                openingParenIndex < formula.length &&
                /\s/.test(formula[openingParenIndex])
            ) {
                openingParenIndex++
            }

            if (formula[openingParenIndex] === '(') {
                return openingParenIndex
            }
        }
    }

    return null
}

const parseFunctionParamsFromOpeningParen = (
    formula: string,
    openingParenIndex: number
): string[] => {
    const startIndex = openingParenIndex + 1
    let depth = 1
    let current = ''
    const params: string[] = []
    let inQuotes = false
    let inBraces = false

    for (let i = startIndex; i < formula.length; i++) {
        const char = formula[i]

        if (char === '"') {
            if (inQuotes && formula[i + 1] === '"') {
                current += char + formula[i + 1]
                i++
                continue
            }
            inQuotes = !inQuotes
            current += char
        } else if (!inQuotes) {
            if (char === '{') {
                inBraces = true
                current += char
            } else if (char === '}') {
                inBraces = false
                current += char
            } else if (char === '(') {
                depth++
                current += char
            } else if (char === ')') {
                depth--
                if (depth === 0) {
                    if (current.trim()) {
                        params.push(current.trim())
                    }
                    break
                }
                current += char
            } else if (char === ',' && !inBraces) {
                params.push(current.trim())
                current = ''
            } else {
                current += char
            }
        } else {
            current += char
        }
    }

    return params
}

export const shouldRefreshWiseOptionsFormula = (formula: string): boolean => {
    const openingParenIndex = findFunctionOpeningParen(formula, 'WISEOPTIONS')
    if (openingParenIndex === null) return false

    const params = parseFunctionParamsFromOpeningParen(
        formula,
        openingParenIndex
    )

    return params.length === 3
}
